module.exports = __webpack_public_path__ + "media/images/off_white_circle_full-70c8607167719bf9d6b8809776c0293b.svg";